import { ThunderAbility } from './ThunderAbility.js';

/**
 * ARC RAY — a focused discharge built on the sandbox's lightning pipeline.
 *
 * It deliberately reuses the tested bolt lifecycle, ribbon shader and particle
 * choreography from Storm Lance, but points them at its own settings block and
 * its own particle buffers. That keeps the two abilities independent while
 * avoiding a second copy of the most delicate lightning code.
 */
export class RayAbility extends ThunderAbility {
  constructor(context) {
    super(context, 'ray');
  }
}
